module.exports = __webpack_public_path__ + "img/movie.601f731f.png";